import { useLocation, useNavigate, useSearchParams } from 'react-router';

import { TASK_ID_SEARCH_PARAM } from '@/utils/task-href';

export const useTaskidToShow = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const taskToShowId = searchParams.get(TASK_ID_SEARCH_PARAM);

  const updateTaskToShowId = (value: null | string) => {
    const params = new URLSearchParams(searchParams);
    if (value) {
      params.set(TASK_ID_SEARCH_PARAM, value);
      // Marks the entry as opened over the list, so closing can step back to it.
      setSearchParams(params, { state: { taskModal: true } });
    } else if ((location.state as { taskModal?: boolean } | null)?.taskModal) {
      // Pushing the list again would leave the modal's entry behind it, and Back would reopen it.
      void navigate(-1);
    } else {
      params.delete(TASK_ID_SEARCH_PARAM);
      // Opened from a link: no list entry behind to step back to.
      setSearchParams(params, { replace: true });
    }
  };

  return [taskToShowId, updateTaskToShowId] as const;
};
